life-and-notification<template>
  <v-container class="setting-display grey lighten-4">
    <div class="setting-display-wrapper">
      <!--smartphone menu-->
    <span v-if="userRole===staffRoleName || userRole===viewerRoleName" class="caption hidden-xs-only orange--text">{{$t('account.function-limit')}}</span>
    <v-layout row wrap justify-center class="setting-display-innner">
        <v-flex xs12 sm5 md5>
          <v-card class="mt-4">
            <v-card-text class="pb-0">
              <div class="clear">
                <div class="image-box"><img src="../assets/images/settings_icon01@2x.png" alt=""></div>
                <h2 class="mb-2 pl-2">{{$t("settings.display-setting")}}</h2>
              </div>

              <v-container fluid class="pa-0">
                <v-layout row wrap>
                  <v-flex xs12 sm4 md4>
                    <v-subheader class="px-0">{{$t("settings.unit")}}</v-subheader>
                  </v-flex>
                  <v-flex xs12 sm5 offset-sm3 class="pt-0">
                    <v-select
                      :items="['gal','liter']"
                      v-model="unit"
                      :label="unit"
                      single-line
                      bottom
                      auto
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-container fluid class="pa-0">
                <v-layout row wrap>
                  <v-flex xs12 sm4 md4>
                    <v-subheader class="px-0">{{$t("settings.pressureUnit")}}</v-subheader>
                  </v-flex>
                  <v-flex xs12 sm5 offset-sm3 class="pt-0">
                    <v-select
                      :items="['PSI', 'MPa']"
                      v-model="pressureUnit"
                      :label="pressureUnit"
                      single-line
                      bottom
                      auto
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-container fluid class="pa-0">
                <v-layout row wrap>
                  <v-flex xs12 sm4 md4>
                    <v-subheader class="px-0">{{$t("settings.temperatureUnit")}}</v-subheader>
                  </v-flex>
                  <v-flex xs12 sm5 offset-sm3 class="pt-0">
                    <v-select
                      :items="['°C', '°F']"
                      v-model="temperatureUnit"
                      :label="temperatureUnit"
                      single-line
                      bottom
                      auto
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-container fluid class="pa-0">
                <v-layout row wrap>
                  <v-flex xs12 sm5 md5>
                    <v-subheader class="px-0">{{$t("settings.timezone")}}</v-subheader>
                  </v-flex>
                  <v-flex xs12 sm6 offset-sm1>
                    <v-select
                      :items="selectItemsTimezone"
                      item-text="text"
                      item-value="value"
                      v-model="timezone"
                      :label="timezone"
                      single-line
                      bottom
                      auto
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>

            </v-card-text>
          </v-card>
        </v-flex>


        <!-- センサー -->
        <v-flex xs12 sm5 md5 offset-sm1 offset-md1 class="mt-4">
          <v-card>
            <v-card-text>
              <div class="clear">
                <div class="image-box"><img src="../assets/images/settings_icon02@2x.png" alt=""></div>
                <h2 class="pl-2">{{$t("settings.available-sensor")}}</h2>
              </div>
              <ul class="mt-4 setting-display-menu">
                <li class="mr-4"><router-link v-if="userRole!==viewerRoleName" to="/settings/plugins#flowsensor">{{$t("sensor.flow")}}</router-link><span v-else class="grey--text">{{$t("sensor.flow")}}</span></li>
                <li class="mr-4"><router-link v-if="userRole!==viewerRoleName" to="/settings/plugins#tdssensor">{{$t("sensor.tds")}}</router-link><span v-else class="grey--text">{{$t("sensor.tds")}}</span></li>
                <li class="mr-4"><router-link v-if="userRole!==viewerRoleName" to="/settings/plugins#pressuresensor">{{$t("sensor.pressure")}}</router-link><span v-else class="grey--text">{{$t("sensor.pressure")}}</span></li>
                <li class="mr-4"><router-link v-if="userRole!==viewerRoleName" to="/settings/plugins#leakagesensor">{{$t("sensor.leakage")}}</router-link><span v-else class="grey--text">{{$t("sensor.leakage")}}</span></li>
                <li class="mr-4"><router-link v-if="userRole!==viewerRoleName" to="/settings/plugins#temperaturesensor">{{$t("sensor.temperature")}}</router-link><span v-else class="grey--text">{{$t("sensor.temperature")}}</span></li>
                <!-- <li><a href="">{{$t("sensor.tds")}}</a></li> -->
              </ul>
            </v-card-text>
          </v-card>
       </v-flex>

       <!-- 通知と寿命 -->
       <v-flex xs12 sm5 md5 class="mt-4">
         <v-card>
           <v-card-text>
             <div class="clear">
             <div class="image-box"><img src="../assets/images/settings_icon03@2x.png" alt=""></div>
             <h2 class="pl-2">{{$t("settings.life-and-notification")}}</h2>
           </div>
             <ul class="mt-4 setting-display-menu">
               <li class="mr-4 grey--text">{{$t("settings.notification-presets")}}</li>
             </ul>
             <ul class="mt-4 setting-display-menu">
               <li class="mr-4"><router-link to="/settings/notifications_mail">{{$t("settings.notification-mail")}}</router-link></li>
             </ul>
           </v-card-text>
         </v-card>
      </v-flex>

      <!-- 組織とユーザ -->
      <v-flex xs12 sm5 md5 offset-sm1 offset-md1 class="mt-4">
        <v-card  >
          <v-card-text>
            <div class="clear">
              <div class="image-box"><img src="../assets/images/settings_icon04@2x.png" alt=""></div>
              <h2 class="pl-2">{{$t("settings.organization-user")}}</h2>
            </div>
            <ul v-if="userRole===rootRoleName" class="mt-4 setting-display-menu">
              <li class="mr-4"><router-link to="/settings/pc_list">{{$t("settings.pc-management")}}</router-link></li>
            </ul>
            <ul v-else class="mt-4 setting-display-menu">
              <li class="mr-4"><router-link v-if="userRole!==staffRoleName && userRole!==viewerRoleName" to="/settings/organizations_detail">{{$t("settings.management-organization")}}</router-link>
                <span v-else class="grey--text">{{$t("settings.management-organization")}}</span></li>
              <li class="mr-4"><router-link v-if="userRole!==staffRoleName && userRole!==viewerRoleName" to="/settings/user_list">{{$t("settings.user-management")}}</router-link>
                <span v-else class="grey--text">{{$t("settings.user-management")}}</span></li>
              <li ><router-link v-if="userRole!==staffRoleName && userRole!==viewerRoleName" to="/settings/user_invite">{{$t("settings.user-invitation")}}</router-link>
                <span v-else class="grey--text">{{$t("settings.user-invitation")}}</span></li>
            </ul>
          </v-card-text>
        </v-card>
     </v-flex>

    </v-layout>
  </div>
  </v-container>
</template>

<script>
import config from '@/config.js'
import moment from 'moment-timezone'

export default {
  data () {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      rootRoleName: config.role.Root,
      staffRoleName: config.role.Staff,
      viewerRoleName: config.role.Viewer,
      unit: '',
      timezone: '',
      pressureUnit: '',
      temperatureUnit: '',
      localTimezone: '',
      selectItemsTimezone: [
        {text: 'UTC', value: 'utc'},
        {text: moment.tz.guess(), value: 'local'},
        {text: this.$t('settings.timezone-location'), value: 'location'}
      ]
    }
  },
  methods: {
    init () {
      this.unit = this.$store.getters.settingParams.unit
      this.timezone = this.$store.getters.settingParams.timezone
      this.pressureUnit = this.$store.getters.settingParams.pressureUnit
      this.temperatureUnit = this.$store.getters.settingParams.temperatureUnit
      this.localTimezone = moment.tz.guess()
    }
  },
  mounted () {
    this.init()
  },
  updated () {
    this.$store.dispatch('setSettingParam', {
      unit: this.unit,
      timezone: this.timezone,
      pressureUnit: this.pressureUnit,
      temperatureUnit: this.temperatureUnit
    })
    .catch(err => {
      console.log(err)
    })
  }
}

</script>

<style>

body{
  font-size: 16px;
}

.setting-display{
  padding: 0 50px 0;
  width: 100%;
  min-height: 100%;
}

.setting-display img{
  vertical-align: bottom;
}

.setting-display-wrapper{
  margin: 0 auto;
}

.setting-display .card{
  min-height: 222px!important;
}

.setting-display .image-box{
  float: left;
}

.setting-display .image-box img{
  max-width: 50px;
  height: auto;
}

.setting-display h2{
  float: left;
  line-height: 50px;
  font-size: 18px;
  font-weight: normal;
}

.setting-display .subheader{
  color: #000!important;
  font-size: 16px;
}

.setting-display .input-group{
  width: 100%;
}

.setting-display .setting-display-menu li{
  float: left;
  padding-left: 5px;
  list-style-type: none;
  color: #5993D7;
}

.setting-display .setting-display-menu li::before{
  float: left;
  display: block;
  content: "";
  left: 4px;
  box-sizing: border-box;
  margin-top: 8px;
  margin-right: 3px;
  width: 4px;
  height: 4px;
  border: 4px solid transparent;
  border-left: 4px solid #231815;
}

.setting-display .setting-display-menu::after,.clearfix::after{
  clear: both;
  content: "";
  display: block;
}

.setting-display .clear{
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// SettingsDisplay.vue?44f0091b